import { getCurrentLazyDensity } from 'owa-fabric-densities';
import { changeDensity } from 'owa-fabric-theme';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { getOpxHostApi } from 'owa-opx';
import DisplayDensityMode from 'owa-service/src/contract/DisplayDensityMode';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default async function initializeDensity() {
    const selectedDensityMode = getUserConfiguration().UserOptions?.DisplayDensityMode;
    if (isHostAppFeatureEnabled('loadThemeFromHostApp')) {
        const opxHostApi = getOpxHostApi();

        opxHostApi.registerThemeChangedHandler?.(
            (isDarkTheme: boolean, densityMode: DisplayDensityMode | undefined) => {
                internalLoadDensity(densityMode || selectedDensityMode);
            }
        );

        internalLoadDensity((await opxHostApi.getOpxDensityMode()) || selectedDensityMode);
    } else {
        internalLoadDensity(selectedDensityMode);
    }
}

async function internalLoadDensity(selectedDensityMode?: DisplayDensityMode) {
    const lazyDensity = getCurrentLazyDensity(selectedDensityMode);
    if (lazyDensity) {
        const density = await lazyDensity.import();
        changeDensity(density);
    }
}
